// @react
import React, { ReactElement, useEffect } from 'react'

/**
 * 5.0.0.1 Profile - Navigation
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2258%3A4687
 *
 */

type PropsType = {
  children: ReactElement | ReactElement[]
  prevPage: number | undefined
  currentPage: number
}
const PaginationScrollWrapper = (props: PropsType): ReactElement | null => {
  /**********************
   * PROPS
   **********************/
  const { children, prevPage, currentPage } = props

  const ref = React.useRef<HTMLInputElement>(null)
  const scrollToRef = (refer: any) => {
    if (refer) {
      const yOffset = -240
      const y =
        refer.current.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  useEffect(() => {
    if (!prevPage) return
    scrollToRef(ref)
  }, [currentPage])

  /**********************
   * RENDER
   **********************/
  return <div ref={ref}>{children}</div>
}

export default PaginationScrollWrapper
